export default "/vietnamese.9e2672d1-ffd76e.woff2";